import Scan from './Scan';

export default Scan;
